import {
    GET_MOVIE_SLIDES,
    GET_RECENT_MOVIES,
    GET_RECENT_MOVIES_SUCCEEDED,
    GET_SOON_IN_CINEMA_MOVIES,
    GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED,
    GET_SOON_MOVIES,
    GET_SOON_MOVIES_SUCCEEDED,
    GET_MOVIE_DETAILS,
    GET_MOVIE_DETAILS_SUCCEEDED,
    ADD_MOVIE_TO_FAVORITE,
    REMOVE_MOVIE_FROM_FAVORITE,
    SEND_MOVIE_REVIEW,
    GET_MOVIE_TIME_SCHEDULE,
    GET_MOVIE_TIME_SCHEDULE_SUCCEEDED,
    GET_ALL_MOVIES,
    GET_ALL_MOVIES_SUCCEEDED,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES,
    ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES,
    GET_ALL_MOVIES_SEE_MORE,
    GET_ALL_MOVIES_SEE_MORE_SUCCEEDED,
    GET_RECENT_MOVIES_PAGE,
    GET_RECENT_MOVIES_PAGE_SUCCEEDED,
    ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES,
    REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES,
    GET_RECENT_MOVIES_PAGE_SEE_MORE,
    GET_SOON_IN_CINEMA_FILTERED_MOVIES,
    GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED,
    GET_MOVIES_SCHEDULE,
    GET_MOVIES_SCHEDULE_SUCCEEDED,
    GET_RECENT_MOVIES_SLIDER,
    GET_RECENT_MOVIES_SLIDER_SUCCEEDED,
    GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED,
    ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES,
    ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE,
    ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    GET_RECOMMENDED_MOVIES,
    GET_RECOMMENDED_MOVIES_SUCCEEDED,
    ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED,
    ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE,
    ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA,
} from './types';

export const requestSliderItems = (payload) => ({
    type: GET_MOVIE_SLIDES,
    payload,
});

export const requestSoonMovies = (payload) => ({
    type: GET_SOON_MOVIES,
    payload,
});

export const getSoonMoviesSucceeded = (payload) => ({
    type: GET_SOON_MOVIES_SUCCEEDED,
    payload,
});

export const requestRecentMovies = (payload) => ({
    type: GET_RECENT_MOVIES,
    payload,
});

export const getRecentMoviesSucceeded = (payload) => ({
    type: GET_RECENT_MOVIES_SUCCEEDED,
    payload,
});


export const getMovieDetails = (payload) => ({
    type: GET_MOVIE_DETAILS,
    payload
})

export const getMovieDetailsSucceeded = (payload) => ({
    type: GET_MOVIE_DETAILS_SUCCEEDED,
    payload
})

export const addMovieToFavorite = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE,
    payload
})

export const removeMovieFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE,
    payload
})

export const sendMovieReview = (payload) => ({
    refresh: true,
    type: SEND_MOVIE_REVIEW,
    payload
})

export const getSoonInCinemaMovies = (payload) => ({
    type: GET_SOON_IN_CINEMA_MOVIES,
    payload,
});

export const getSoonInCinemaMoviesSucceeded = (payload) => ({
    type: GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED,
    payload,
});

export const getMovieTimeSchedule = (payload) => ({
    type: GET_MOVIE_TIME_SCHEDULE,
    payload
})

export const getMovieTimeScheduleSucceeded = (payload) => ({
    type: GET_MOVIE_TIME_SCHEDULE_SUCCEEDED,
    payload
})

export const getAllMovies = (payload) => ({
    type: GET_ALL_MOVIES,
    payload
})

export const getAllMoviesSucceeded = (payload) => ({
    type: GET_ALL_MOVIES_SUCCEEDED,
    payload
})

export const getAllMoviesSeeMore = (payload) => ({
    type: GET_ALL_MOVIES_SEE_MORE,
    payload
})

export const getAllMoviesSeeMoreSucceeded = (payload) => ({
    type: GET_ALL_MOVIES_SEE_MORE_SUCCEEDED,
    payload
})

export const addMovieToFavoriteFromAllMovies = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES,
    payload
})

export const removeMovieFromFavoriteFromAllMovies = (filmId, payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES,
    filmId,
    payload
})

export const getRecentMoviesPage = (payload) => ({
    type: GET_RECENT_MOVIES_PAGE,
    payload
})

export const getRecentMoviesPageSucceeded = (payload) => ({
    type: GET_RECENT_MOVIES_PAGE_SUCCEEDED,
    payload
})

export const addMovieToFavoriteFromRecentMovies = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES,
    payload
})

export const removeMovieFromFavoriteFromRecentMovies = (filmId, payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES,
    filmId,
    payload
})

export const getRecentMoviesPageSeeMore = (payload) => ({
    type: GET_RECENT_MOVIES_PAGE_SEE_MORE,
    payload
})

export const getRecentMoviesPageSeeMoreSucceeded = (payload) => ({
    type: GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED,
    payload
})

export const addMovieToFavoriteFromHomeRecentMovies = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES,
    payload
})

export const removeMovieFromFavoriteFromHomeRecentMovies = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES,
    payload
})


export const getSoonInCinemaFilteredMovies = (payload) => ({
    type: GET_SOON_IN_CINEMA_FILTERED_MOVIES,
    payload,
});

export const getSoonInCinemaFilteredMoviesSucceeded = (payload) => ({
    type: GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED,
    payload,
});


export const getMovieSchedule = (payload) => ({
    type: GET_MOVIES_SCHEDULE,
    payload
})

export const getMovieScheduleSucceeded = (payload) => ({
    type: GET_MOVIES_SCHEDULE_SUCCEEDED,
    payload
})

export const getRecentMoviesSlider = (payload) => ({
    type: GET_RECENT_MOVIES_SLIDER,
    payload,
});

export const getRecentMoviesSliderSucceeded = (payload) => ({
    type: GET_RECENT_MOVIES_SLIDER_SUCCEEDED,
    payload,
});

export const addMovieToFavoriteFromSchedule = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE,
    payload
})

export const removeMovieFromFavoriteFromSchedule = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE,
    payload
})

export const addMovieToFavoriteFromScheduleCarouselItem = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    payload
})

export const removeMovieFromFavoriteFromScheduleCarouselItem = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    payload
})

export const getRecommendedMovies = (payload) => ({
    type: GET_RECOMMENDED_MOVIES,
    payload
})

export const getRecommendedMoviesSucceeded = (payload) => ({
    type: GET_RECOMMENDED_MOVIES_SUCCEEDED,
    payload
})

export const addMovieToFavoriteFromRecommended = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED,
    payload
})

export const removeMovieFromFavoriteFromRecommended = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED,
    payload
})

export const addMovieToFavoriteFromBoxOffice = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE,
    payload
})

export const removeMovieFromFavoriteFromBoxOffice = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE,
    payload
})

export const addMovieToFavoriteFromSoonInCinema = (payload) => ({
    refresh: true,
    type: ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA,
    payload
})

export const removeMovieFromFavoriteFromSoonInCinema = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA,
    payload

})




// WEBPACK FOOTER //
// ./src/SHARED/actions/movies.actions.js